import CropperTool from '../cropper';
import { CloseIcon } from './Icons';

interface FileItemModalsProps {
  file: any;
  mimeType: string;
  cropImage: any;
  modalImage: any;
  showCropTool: boolean;
  showImageModal: boolean;
  closeCropTool: () => void;
  setShowImageModal: (show: boolean) => void;
}

const FileItemModals = ({
  file,
  mimeType,
  cropImage,
  modalImage,
  showCropTool,
  showImageModal,
  closeCropTool,
  setShowImageModal,
}: FileItemModalsProps) => (
  <>
    {showCropTool && (
      <CropperTool
        file={file}
        toggleCropper={closeCropTool}
        image={`data:image/jpeg;base64,${cropImage}`}
      />
    )}
    {modalImage.base64 && showImageModal && (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
        onClick={() => setShowImageModal(false)}
      >
        <CloseIcon
          className="absolute w-8 h-8 transition-all cursor-pointer lg:w-7 lg:h-7 fill-white stroke-white top-3 right-3 lg:right-5 lg:top-5 hover:stroke-white"
        />
        <img
          src={`data:${mimeType};base64,${modalImage.base64}`}
          alt={file.file}
          className="max-h-[90vh] max-w-[90vw] shadow-lg"
          onClick={(e) => e.stopPropagation()}
        />
      </div>
    )}
  </>
);

export default FileItemModals;
